/**
 * This object maps the color palette defined in `styles/variables.scss file`.
 * Import this const into a component file so there is no need to hard-code hex value for colors in <script>, e.g.
 *   import {ADS_Colors} from '@nswdoe/doe-ui-core';
 * If need to use the colors in <template>, define a property in data() so it can be used in <template>, e.g.
 *   data() {
      return {
        ADS_Colors
      }
    },
 */
// doe_colour palette
export const ADS_Colors = {
// Primary
  Navy: '#041E42',
  Red: '#CE0037',
  Light_Blue: '#C8DCF0',

  Navy_Dark: '#6BACE4',
  Red_Dark: '#EE3C48',
  Light_Blue_Dark: '#4C4F55',

// - new updates Aug 2022 - Primary
  PRIMARY_BLUE: '#002664',
  PRIMARY_RED: '#D7153A',
  PRIMARY_TEAL: '#CBEDFD',
  PRIMARY_BLUE_DARK: '#407EC9',
  PRIMARY_RED_DARK: '#FFB8C1',
  PRIMARY_TEAL_DARK: '#6CACE4',

// Secondary
  Blue_1: '#1D428A',
  Blue_2: '#407EC9',
  Blue_3: '#6CACE4',
  Red_2: '#EE3C48',
  Red_3: '#F3B8B5',

  Blue_1_Dark: '#407EC9',
  Blue_2_Dark: '#6BACE4',
  Blue_3_Dark: '#A4D1F8',
  Red_2_Dark: '#ED5660',
  Red_3_Dark: '#FBCECD',

// - new updates Aug 2022 - Secondary
  SECONDARY_BLUE: '#407EC9',
  TERTIARY_BLUE: '#6CACE4',
  SECONDARY_RED: '#FFB8C1',
  SECONDARY_GREY: '#EBEBEB',
  SECONDARY_BLUE_DARK: '#6CACE4',
  TERTIARY_BLUE_DARK: '#CBEDFD',
  SECONDARY_RED_DARK: '#D7153A',
  SECONDARY_GREY_DARK: '#EBEBEB',

// Notification
  Info_Blue: '#2E5299',
  Success_Green: '#00AA45',
  Warning_Orange: '#F3631B',
  Error_Red: '#D7153A',

  Info_Blue_Dark: '#7EA0E4',
  Success_Green_Dark: '#A8EDB3',
  Warning_Orange_Dark: '#FFCE99',
  Error_Red_Dark: '#FFB8C1',

// Greys
  Dark: '#121212',
  Dark_80: '#333333',
  Dark_70: '#4C4F55',
  Dark_60: '#6D7079',
  Light_40: '#A0A5AE',
  Light_20: '#E4E4E6',
  Light_10: '#F4F4F7',
  White: '#FFFFFF',

// - new updates Aug 2022 - Greys
  GREY_01: '#22272B',
  GREY_02: '#495054',
  GREY_03: '#CDD3D6',
  GREY_04: '#EBEBEB',
  GREY_01_DARK: '#EBEBEB',
  GREY_02_DARK: '#CDD3D6',
  GREY_03_DARK: '#EBEBEB',
  GREY_04_DARK: '#EBEBEB',

// Tints for dark theme
  DP01: '#1E1E1E',
  DP02: '#232323',
  DP03: '#252525',
  DP04: '#272727',
  DP06: '#2C2C2C',
  DP08: '#2E2E2E',
  DP12: '#333333',
  DP16: '#363636',
  DP24: '#383838',

// Tints for navy background
  Navy_Light_1: '#1A3B69',
  Navy_Light_2: '#264776',
  Navy_Light_3: '#2E5285',
  Navy_Dark_1: '#031631',

// Custom tints
  Custom_Navy_2: '#DCE4EC',
  Custom_Navy_3: '#1A3B69',

// - new updates Aug 2022 - New Colors
  FUSCHIA_1: '#65004D',
  FUSCHIA_1_DARK: '#F4B5E6',
  PURPLE_1: '#441170',
  PURPLE_1_DARK: '#CEBFFF',
  TEAL_1: '#0B3F47',
  TEAL_1_DARK: '#8CDBE5',
}
